<template>
		<div style="background-color:#F5F5F5;width:100%;">
			<!-- 主文 -->
			<div style="display: flex;justify-content: center;align-items: center;">
				<div>
					<div style="background-color:#F5F5F5;display: flex;">
						<div class="zwk" style="background-color:white;padding:10px 10px 0px 20px;" >
							<div class="zxls">招贤纳士</div>
							<div style="padding:5px 0 5px;margin-bottom:10px;">
								<div style="font-size:14px;text-align:left;"></div>
								<div style="display:flex;flex-wrap: wrap;">
									<div v-for="(item,index) in titles" :key="index" style="display: flex;" @click="tap(index)">
										<a class="kesc" :style="index==tabIndexs?'color:#20919D':''">{{item.name}}</a>
										<div  class="Lines"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="zwk2" style="background-color:white;padding:10px 10px 0px 20px;">
							<div class="zxls">招贤纳士</div>
							<div>
								<div style="text-align: left;margin-top: 10px;display: flex;">
									<img :src="urls+titlestwo.url" style="width: 516px;height: 262px;" />
									<div class="artitle_media">
										<video preload controls style="width: 332px;height: 262px;margin-left: 20px;">
										      <source :src="urls+titlestwo.video_url" type="video/mp4" v-if="titlestwo&&titlestwo.video_url" />
										 </video>
									</div>
								</div>
								<div v-html="titlestwo.info" style="text-align:left;font-size:14px;" class="imgsa"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"my",
		components:{
		},
		data() {
			return {
				id:0,
				videurl:'',
				url:'https://www.baidu.com/',
				tabIndex:7,
				tabIndexs:0,
				urls:"http://cxq-api.cqlink.club/",
				titles:'',
				titlestwo:'',
				
			}
		},
		created() {
			this.nrxx()
		},
		methods: {
		fhsy(){
			this.$router.push({name:'page'});
			this.$store.commit("navbgshow",0)
		},
		tap:function(e){
			this.tabIndexs=e
			this.id=e;
			this.titlestwo=this.titles[this.id]
			// this.nrxx()
			
		},
		nrxx:function(){
			//获取关于我们信息接口
			axios({
			    url: `${base.url}/api/user/recruit`,
			    method: 'post',
			    data:''
			}).then((res) => {
						if(res){
							this.titles=res.data
							this.urls=res.url
							this.titlestwo=this.titles[this.id]
						}
			        })
		}
		},
	}
</script>

<style lang="scss" >
	body{
		width:100%;
		height:100%;
	}
	.imgsa{
		img{
			width:100%;
			// height:200rpx;
		}
	}
	.zwk{
		margin:0px 10px 0px 10px;
		width: 240px;
		// height:695px;
		background-color:#ffffff;
	}
	.zwk2{
		width: 863px;
		// height:695px;
		background-color:#ffffff;
	}
	.kesc{
		font-size: 14px;
		margin-left:2px;
		margin-top:5px ;
		color:#848484;
	}
	.kesc:hover{
		cursor:pointer;
		color:#20919D !important;
	}
	.Lines{
		width:1px;
		height: 12px;
		background-color:#CCCCCC;
		margin:10px 5px 10px;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		font-weight:bold;
		color:#181818;
		font-size:16px;
	}
	.router-link-active {
	  text-decoration: none;
	}
	a {
	  text-decoration: none;
	}
	.artitle_media{
	    text-align: center;
	}
	.artitle_media video{
	    object-fit:fill;
	    width:100%;
	    height:100%;
	    margin-left: auto;
	    margin-right: auto;
		outline:none
	}
</style>
